import { render } from "./AboutReverse.vue?vue&type=template&id=f9a540c0&scoped=true"
import script from "./AboutReverse.vue?vue&type=script&lang=js"
export * from "./AboutReverse.vue?vue&type=script&lang=js"

import "./AboutReverse.vue?vue&type=style&index=0&id=f9a540c0&scoped=true&lang=css"

import exportComponent from "/Users/czh/Desktop/czh/yog_website/lada/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9a540c0"]])

export default __exports__